module.exports = __webpack_public_path__ + "assets/media/chat-action.e0e57af4.mp3";